<script setup>
import {computed, onMounted, ref} from "vue";
import dashboardService from "@/services/ecosystem/dashboard.service";

const activities = ref([]);
const page = ref(1);

const displayedActivities = computed(() => activities.value.slice(0, page.value * 5));
const hasMore = computed(() => activities.value.length > displayedActivities.value.length);

onMounted(() => {
    getActivities();
})

async function getActivities() {
    const {data} = await dashboardService.getActivities();

    activities.value = data;
}
</script>

<template>
    <div v-if="activities.length" class="dashboard-page__plate">
        <header class="dashboard-page__plate__header">
            <h6 class="heading6 heading6--activity">Activity</h6>
        </header>

        <div class="dashboard-page__plate__content">
            <ul class="dashboard-page__activity">
                <li
                    v-for="(activity, index) in displayedActivities"
                    :key="index"
                    :class="{
                        'dashboard-page__activity__upload': activity.action === 'added',
                        'dashboard-page__activity__like': activity.action === 'liked',
                        'dashboard-page__activity__tracker': activity.action === 'advanced',
                    }"
                >
                    <div>
                        <h6 class="heading6">
                            <a :href="`/startups/${activity.startup_id}`" target="_blank">{{activity.startup_name}}</a>
                            <template v-if="activity.action === 'added'">
                                submitted to
                            </template>
                            <template v-if="activity.action === 'liked'">
                                matched to
                            </template>
                            <template v-if="activity.action === 'advanced'">
                                advanced to project
                            </template>
                        </h6>

                        <p v-if="activity.action !== 'advanced'">
                            <a :href="`/needs/${activity.need_id}`" target="_blank">{{activity.need_name}}</a>
                        </p>
                    </div>

                    <time class="dashboard-page__activity__time">{{activity.period}}</time>
                </li>
            </ul>

            <div v-if="hasMore" class="text-center my-3">
                <a @click="page++" class="link">Load More</a>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
